import script from "./TreeEditorWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeEditorWidget.vue?vue&type=script&setup=true&lang=js"

import "./TreeEditorWidget.vue?vue&type=style&index=0&id=2f7097da&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7097da"]])

export default __exports__